import Link from 'next/link';
import { FeaturedPostContainer, FeaturedTileContent, FeaturedTileDescriptionHeadline, FeaturedTileMedia, FeaturedTileText, FeaturedTileTimestamp } from '../../styles/blog/featured';
import CoverImage from './CoverImage';
import Date from './Date';

export default function FeaturedPostTile({
  title,
  coverImage,
  date,
  excerpt,
  author,
  slug
}) {
  return (
    <FeaturedPostContainer>
      <Link href={`/blog/${slug}`} passHref={true} aria-label={title}>
        <div className="inner-link-wrapper">
          <FeaturedTileMedia className='tile-media'>
            {coverImage && (
              <CoverImage title={title} coverImage={coverImage} slug={slug} />
            )}
          </FeaturedTileMedia>
          <FeaturedTileText>
            <FeaturedTileContent>
              <FeaturedTileDescriptionHeadline>
                {title}
              </FeaturedTileDescriptionHeadline>
              <FeaturedTileTimestamp>
                <Date dateString={date} />
              </FeaturedTileTimestamp>
            </FeaturedTileContent>
          </FeaturedTileText>
        </div>
      </Link>
    </FeaturedPostContainer>
  )
}
